/* This is the EMIS private schoolRoom components */

<template>
  <v-container>
    <div>
      <span v-html="title"></span>
    </div>
    <div>
      <table
        style="height: 43px"
        width="350px;"
        border="1px;"
        cellspacing="0px;"
      >
        <tbody>
          <tr>
            <td
              style="
                width: 200px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              បន្ទប់ដោយឡែកសម្រាប់
            </td>
            <td
              style="
                width: 150px;
                height: 32px;
                text-align: center;
                vertical-align: middle;
              "
            >
              ស្ថានភាព
            </td>
          </tr>
          <tr v-for="(item, index) in roomCond.length" :key="index">
            <td
              style="
                width: 102px;
                height: 25px;
                text-align: left;
                vertical-align: middle;
              "
            >
              {{ roomCond[index] }}
            </td>
            <td
              style="
                width: 102px;
                height: 32px;
                text-align: center;
                vertical-align: middle;
              "
            >
              <v-select
                class="py-0 px-1"
                v-model="data[index].dt[0]"
                :items="condition"
                item-text="text"
                item-value="value"
                outline
                hide-details
                @keypress.native="onSelect($event, index)"
              >
              </v-select>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import { roomCond, condition } from "@/utils/priascf/commonVariables.js";
export default {
  props: ["data", "title"],
  data() {
    return {
      roomCond: roomCond,
      condition: condition,
    };
  },
  methods: {
    onSelect: function (event, index) {
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 52) {
        this.data[index].dt[0] = charCode - 48;
        this.$forceUpdate();
      }
    },
  },
};
</script>

<style scoped>
.input-group--select >>> .input-group__selections__comma {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 12px;
  padding: 1px 1px 1px 0;
}
</style>